var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("animate-number", {
    key: _vm.dTo,
    attrs: {
      from: _vm.dFrom,
      to: _vm.dTo,
      formatter: _vm.Numberformatter,
      duration: _vm.duration,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }